import React from 'react';
// import styled from 'styled-components'
import Recaptcha from 'react-google-invisible-recaptcha';

class SubmitForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      registration: null,
      recaptchaResponse: null
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onResolved = this.onResolved.bind(this);
  }

  render() {
    return (
      <div>
        <form onSubmit={this.onSubmit}>
          <p>Please enter your vehicle registration:</p>
          <div className="mb-3">
            <input type="text" className="input rounded" name="reg" id="reg" maxLength="10" minLength="2" pattern="[a-zA-Z0-9\s]+"
              required autoFocus title="Please enter valid vehicle registration"
              onChange={(e) => this.setState({ registration: e.target.value })} />
          </div>
          {
            this.props.allowDynamicExemptionDuration &&
            <div>
              <p>and the length of your stay:</p>
              <div className="mb-3">
                <select className="input rounded" name="duration" id="duration" maxLength="10" minLength="2" pattern="[a-zA-Z0-9\s]+"
                  required autoFocus title="Please select your required exemption duration" onChange={(e) => this.setState({ exemptionDuration: e.target.value })}>
                  <option>-- PLEASE SELECT --</option>
                  {[...Array(this.props.exemptionDuration)].map((e, i) => <option key={i} value={i + 1}>{i + 1} {this.props.exemptionDurationType}</option>)}
                </select>
              </div>
            </div>
          }
          <div className="mb-3">
            <input type="submit" value="Submit"
              className="btn btn-large btn-primary rounded mx-auto" />

            {!process.env.REACT_APP_DISABLE_CAPTCHA && <Recaptcha inline
              ref={ref => this.recaptcha = ref}
              sitekey={process.env.REACT_APP_GOOGLE_API_KEY}
              onResolved={this.onResolved} />}
          </div>
        </form>
      </div>
    );
  }

  onResolved() {
    var resp = this.recaptcha.getResponse();
    this.setState({
      registration: this.state.registration,
      exemptionDuration: this.state.exemptionDuration,
      recaptchaResponse: resp
    });

    this.props.onSubmitRegistration(this.state);
  }

  onSubmit(event) {
    event.preventDefault();
    if (!process.env.REACT_APP_DISABLE_CAPTCHA) {
      this.recaptcha.execute();
    } else {
      this.setState({
        registration: this.state.registration,
        exemptionDuration: this.state.exemptionDuration,
        recaptchaResponse: undefined
      });

      this.props.onSubmitRegistration(this.state);
    }
  }
}

export default SubmitForm;